import { takeEvery } from 'redux-saga/effects';
import { AdminOrganizationsApi } from 'api';
import { sagasHandlersFactory } from 'store/entities/utils';
import * as actions from './actions';

export const handleGetAdminOrganizationStatistics = sagasHandlersFactory.createGetOneRequestHandler({
  actions: actions.getAdminOrganizationStatistics,
  request: AdminOrganizationsApi.getAdminOrganizationStatistics,
  requestArgsBuilder: (action) => {
    const { id, params = {} } = action.payload;
    return [id, { params }];
  },
  transformResponse: (response, action) => ({
    id: action.payload.id,
    ...response,
  }),
});

export default function* adminOrganizationStatistics() {
  yield takeEvery(actions.getAdminOrganizationStatistics.request.type, handleGetAdminOrganizationStatistics);
}
